export const REDUX_STORE = {
  PERSIST_STORE_NAME: 'root',
  PERSIST_EXPIRY_NAME: 'exp',
  PERSIST_EXPIRY_DURATION: 1000 * 60 * 60 * 1, //1 Hour
};

export const MFINE_PLAY_STORE = {
  RATINGS: '4.6',
  RATINGS_TEXT: 'rating',
  DOWNLOADS: '10 Lakh +',
  DOWNLOADS_TEXT: 'trusted users',
};

export const cookieKey = 'sa_t';

export const enCookieKey = 'en_t';

export const OFFSET = '-150px';

export const OTP_TYPE = 'accessReport';

export const reportUrlKey = 'r_url';
export const reportUserKey = 'r_uid';
export const reportProfileKey = 'r_sp';

export const availableWebAssessments = {
  SKINCARE: {
    URL: {
      DEV:
        'https://devwp.mfine.co/assessment/skincare/report?rs=1100&channel=website&utm_source=landingpage&utm_medium=banner&utm_campaign=SKINCARE&uid={userId}&referrer=SurveySparrow',
      QA:
        'https://self-checks.mfine.co/s/V2-Free-Skin-Test---Clone/tt-kCBZvhfySNnLnnBwor3rvi?channel=website&utm_source=landingpage&utm_medium=banner&utm_campaign=SKINCARE&uid={userId}&referrer=SurveySparrow',
      PROD:
        'https://self-checks.mfine.co/s/Free-Skin-Test/tt-YCmVJ?channel=website&utm_source=landingpage&utm_medium=banner&utm_campaign=SKINCARE&uid={userId}&referrer=SurveySparrow',
      LOCAL:
        'http://localhost:3000/assessment/skincare/report?rs=1100&channel=website&utm_source=landingpage&utm_medium=banner&utm_campaign=SKINCARE&uid={userId}&referrer=SurveySparrow',
    },
  },
  HRA: {
    URL: {
      DEV:
        'https://devwp.mfine.co/assessment/hra/report?rs=1048&channel=website&utm_source=landingpage&utm_medium=banner&utm_campaign=HRA&uid={userId}',
      QA:
        'https://self-checks.mfine.co/s/HRA---QA/tt-d0Mt1?&channel=website&utm_source=landingpage&utm_medium=banner&utm_campaign=HRA&uid={userId}',
      PROD:
        'https://self-checks.mfine.co/s/HRA/tt-dDSBKKGyQXGjjh1WvXBNMe?channel=website&utm_source=landingpage&utm_medium=banner&utm_campaign=HRA&uid={userId}',
      LOCAL:
        'http://localhost:3000/assessment/hra/report?rs=1048&channel=website&utm_source=landingpage&utm_medium=banner&utm_campaign=HRA&uid={userId}',
    },
    REFS: ['teamcomputers', 'mfine'],
  },
};
